module.exports = __webpack_public_path__ + "static/media/10325367_789226737784215_7699705597989847400_n.60912c06.jpg";